import { createApi as coreCreateApi } from './core';
import { CoverageRequest, CoverageResponse, Rule } from './insurance.types';
import { Response } from './insurance.changehealthcare.types';

declare const healConfig: any;

function createApi() {
  return coreCreateApi({ baseURL: healConfig.apiBaseUrl + '/insurance', skipInterceptors: true });
}

export function fetchRules(): Promise<Rule[]> {
  return createApi()
    .then((api) => api.get<any>('/v1/rule'))
    .then((r) => (r.ok ? r.data : []));
}

export function createRule(rule: Partial<Rule>): Promise<Rule> {
  return createApi()
    .then((api) => api.post<any>('/v1/rule', rule))
    .then((r) => (r.ok ? r.data : Promise.reject(new Error('Failed to create rule'))));
}

// TODO: This does not exist on the server -- do a create, followed by delete for now.
export function updateRule(rule: Partial<Rule>): Promise<Rule> {
  return createRule(rule).then((r) => {
    return deleteRule(rule.id!).then(() => r);
  });
  // return createApi()
  //   .then((api) => api.post<any>(`/v1/rule/${rule.id}`, rule))
  //   .then((r) => (r.ok ? r.data : Promise.reject(new Error('Failed to create rule'))));
}

export function deleteRule(ruleId: string): Promise<boolean> {
  return createApi()
    .then((api) => api.delete<any>(`/v1/rule/${ruleId}`))
    .then((r) => r.ok);
}

export function coverage(body: CoverageRequest): Promise<CoverageResponse> {
  return createApi()
    .then((api) => api.post<any>(`/v2/coverage`, body))
    .then((r) => (r.ok ? r.data : Promise.reject(r.data)));
}

export function changeCoverage(body: any): Promise<Response> {
  return coreCreateApi({ baseURL: healConfig.apiBaseUrl + '/changehealthcare', skipInterceptors: true })
    .then((api) => api.post<Response>('/medicalnetwork/eligibility/v3', body))
    .then((r) => (r.ok && r.data ? r.data : Promise.reject(r.data)));
}
